import { BreadcrumbNav } from "components/molecules";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MonthOptions, PageMode } from "utils/constant";
import { useFormik } from "formik";
import moment from "moment";
import UjiSilangService from "services/UjiSilang";
import {
  errorToastNotif,
  getDataFromLocalStorage,
  successToastNotif,
} from "utils/common";
import InputDate from "components/atoms/InputDate";
import InputSelect from "components/atoms/InputSelect";
import InputField from "components/atoms/InputField";
import Button from "components/atoms/Button";
import { isValidRangeNumber } from "utils/helpers";
import InputCheckbox from "components/atoms/InputCheckbox";

const ujiSilangService = new UjiSilangService();

const Form = ({ pageMode, changeMode }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const { currentUser } = useSelector((state) => state.authReducer);

  const formik = useFormik({
    initialValues: {
      parasyte: [],
      jumsdneg: undefined,
      jumsdpos_mix: undefined,
      jumsdpos_pf: undefined,
      jumsdpos_pv: undefined,
      jumsdpos_po: undefined,
      jumsdpos_pm: undefined,
    },
    validate: (values) => {
      const errors = {};
      if (!values.year) errors.year = "Tahun wajib diisi";
      if (!values.month) errors.month = "Bulan wajib diisi";
      if (!values.pjlab) errors.pjlab = "Petugas mikroskopis wajib diisi";
      if (!isValidRangeNumber(values.jumsdneg, 0, 999)) {
        errors.jumsdneg = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumsdpos_mix, 0, 999)) {
        errors.jumsdpos_mix = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumsdpos_pf, 0, 999)) {
        errors.jumsdpos_pf = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumsdpos_pv, 0, 999)) {
        errors.jumsdpos_pv = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumsdpos_po, 0, 999)) {
        errors.jumsdpos_po = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumsdpos_pm, 0, 999)) {
        errors.jumsdpos_pm = "Nilai harus antara 0 dan 999";
      }

      if (values.jumsdpos_mix > 0 && !values.parasyte?.length) {
        errors.parasyte = "Jenis parasit wajib diisi";
      }

      return errors;
    },
    onSubmit: async (values) => {
      let payload = {
        ...values,
        province_id: currentUser?.province_id,
        district_id: currentUser?.district_id,
        fasyankes_id: currentUser?.fasyankes_id,
        year: moment(values.year).format("YYYY"),
        month: values.month,
        jumsdfaskes:
          +values.jumsdneg +
          +values.jumsdpos_mix +
          +values.jumsdpos_pf +
          +values.jumsdpos_pv +
          +values.jumsdpos_po +
          +values.jumsdpos_pm,
      };

      switch (pageMode) {
        case PageMode.add:
          await ujiSilangService
            .add(payload)
            .then((res) => {
              changeMode(PageMode.view);
              successToastNotif("Data berhasil ditambahkan");
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
        case PageMode.edit:
          await ujiSilangService
            .update(payload, selectedItem?.id)
            .then((res) => {
              changeMode(PageMode.view);
              successToastNotif("Data berhasil diperbarui");
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
      }
    },
  });

  useEffect(() => {
    if (pageMode === PageMode.edit) {
      const dataFromStorage = JSON.parse(
        getDataFromLocalStorage("SELECTED_ITEM")
      );

      setSelectedItem(dataFromStorage);
      formik.setValues({ ...dataFromStorage });
    }
  }, []);

  return (
    <>
      <BreadcrumbNav
        items={[
          {
            label: "Uji Silang Fasyankes",
            onClick: () => changeMode(PageMode.view),
          },
          {
            label:
              pageMode === PageMode.add
                ? "Tambah Data Uji Silang Fasyankes"
                : "Edit Data Uji Silang Fasyankes",
          },
        ]}
      />
      <h1 className="page-title">
        {pageMode === PageMode.add
          ? "Tambah Data Uji Silang Fasyankes"
          : "Edit Data Uji Silang Fasyankes"}
      </h1>
      {/* Informasi wilayah */}
      <div className="informasi-wilayah">
        <section className="list-item">
          <p className="item-label">Provinsi</p>
          <p className="item-value">
            {currentUser?.province_id?.split("|")[1]}
          </p>
        </section>
        <hr />
        <section className="list-item">
          <p className="item-label">Kab/Kota</p>
          <p className="item-value">
            {currentUser?.district_id?.split("|")[1]}
          </p>
        </section>
        <hr />
        <section className="list-item">
          <p className="item-label">Fasyankes</p>
          <p className="item-value">
            {currentUser?.fasyankes_id?.split("|")[1]}
          </p>
        </section>
      </div>

      <div className="form-grouping">
        <p className="warning" style={{ marginBottom: "24px" }}>
          NOTE: <span>* WAJIB DIISI</span>
        </p>

        <div className="grid grid-cols-2 gap-4">
          <InputDate
            label={"Tahun"}
            name={"year"}
            placeholder={"Pilih tahun"}
            dateFormat={"YYYY"}
            onChange={(e) => {
              const selectedYear = moment(e).format("YYYY");
              formik.handleChange("year")(selectedYear);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.year}
            error={formik.errors.year && formik.touched.year}
            errorMessage={formik.errors.year}
            isRequired={true}
          />
          <InputSelect
            label={"Bulan"}
            name={"month"}
            placeholder={"Pilih bulan"}
            data={MonthOptions}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              formik.handleChange("month")(selectedValue);
            }}
            onBlur={formik.handleBlur}
            value={MonthOptions.find(
              (item) => item.value === formik.values.month
            )}
            error={formik.errors.month && formik.touched.month}
            errorMessage={formik.errors.month}
            isRequired={true}
          />
          <InputField
            label={"Nama petugas mikroskopis"}
            name={"pjlab"}
            type={"text"}
            placeholder={"Masukkan nama petugas mikroskopis"}
            {...formik.getFieldProps("pjlab")}
            error={formik.errors.pjlab && formik.touched.pjlab}
            errorMessage={formik.errors.pjlab}
            isRequired={true}
          />
          <InputField
            label={"Jumlah sedian darah negatif (0-999)"}
            name={"jumsdneg"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan jumlah sedian darah negatif"}
            {...formik.getFieldProps("jumsdneg")}
            error={formik.errors.jumsdneg && formik.touched.jumsdneg}
            errorMessage={formik.errors.jumsdneg}
            isRequired={true}
          />
          <InputField
            label={"Jumlah sedian darah positif (mix) 0-999"}
            name={"jumsdpos_mix"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan jumlah sedian darah positif (mix)"}
            {...formik.getFieldProps("jumsdpos_mix")}
            error={formik.errors.jumsdpos_mix && formik.touched.jumsdpos_mix}
            errorMessage={formik.errors.jumsdpos_mix}
            isRequired={true}
          />
          {formik.values.jumsdpos_mix > 0 && (
            <InputCheckbox
              label="Jenis parasit"
              name="parasyte"
              options={[
                { label: "P.falciparum", value: "P.Falciparum" },
                { label: "P.malariae", value: "P.Malariae" },
                { label: "Probable knowlesi", value: "Probable Knowlesi" },
                { label: "P.vivax", value: "P.Vivax" },
                { label: "P.ovale", value: "P.Ovale" },
              ]}
              {...formik.getFieldProps("parasyte")}
              selectedOption={formik.values.parasyte}
              isItalic={true}
              error={formik.errors.parasyte && formik.touched.parasyte}
              errorMessage={formik.errors.parasyte}
              isRequired={true}
              className="grid grid-cols-3 gap-1"
            />
          )}
          <InputField
            label={"Jumlah sedian darah positif (pf) 0-999"}
            name={"jumsdpos_pf"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan jumlah sedian darah positif (pf)"}
            {...formik.getFieldProps("jumsdpos_pf")}
            error={formik.errors.jumsdpos_pf && formik.touched.jumsdpos_pf}
            errorMessage={formik.errors.jumsdpos_pf}
            isRequired={true}
          />
          <InputField
            label={"Jumlah sedian darah positif (pv) 0-999"}
            name={"jumsdpos_pv"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan jumlah sedian darah positif (pv)"}
            {...formik.getFieldProps("jumsdpos_pv")}
            error={formik.errors.jumsdpos_pv && formik.touched.jumsdpos_pv}
            errorMessage={formik.errors.jumsdpos_pv}
            isRequired={true}
          />
          <InputField
            label={"Jumlah sedian darah positif (po) 0-999"}
            name={"jumsdpos_po"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan jumlah sedian darah positif (po)"}
            {...formik.getFieldProps("jumsdpos_po")}
            error={formik.errors.jumsdpos_po && formik.touched.jumsdpos_po}
            errorMessage={formik.errors.jumsdpos_po}
            isRequired={true}
          />
          <InputField
            label={"Jumlah sedian darah positif (pm) 0-999"}
            name={"jumsdpos_pm"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan jumlah sedian darah positif (pm)"}
            {...formik.getFieldProps("jumsdpos_pm")}
            error={formik.errors.jumsdpos_pm && formik.touched.jumsdpos_pm}
            errorMessage={formik.errors.jumsdpos_pm}
            isRequired={true}
          />
        </div>

        <div className="form_action">
          <Button
            variant={"tertiary"}
            size={"normal"}
            onClick={() => changeMode(PageMode.view)}
          >
            Batalkan
          </Button>
          <Button
            variant={"primary"}
            size={"normal"}
            type="button"
            onClick={formik.handleSubmit}
            isDisabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          >
            Simpan Data
          </Button>
        </div>
      </div>
    </>
  );
};

export default Form;
